import { getScrollContainer } from '@theme/scroll-container';

/**
 * Handles same-page anchor links (e.g. hero CTAs linking to `#cleau-shop`).
 *
 * Native `<a href="#id">` navigation only scrolls `document`/`window`, but this
 * theme's desktop "squeeze" layout scrolls `.page-wrapper` instead (see
 * scroll-container.js). Native anchors silently no-op in that layout, so this
 * listener resolves the correct scroll container itself and offsets by the
 * sticky header height.
 *
 * Uses `behavior: 'instant'`, matching scroll-container.js's own documented
 * workaround: animated scrollTo() calls silently fail on `.page-wrapper`
 * despite its CSS `scroll-behavior: smooth`, so instant is the reliable path.
 */
document.addEventListener('click', (event) => {
  if (event.defaultPrevented || event.button !== 0) return;

  const link = event.target.closest('a[href^="#"]');
  if (!link) return;

  const hash = link.getAttribute('href');
  if (!hash || hash.length < 2) return;

  const target = document.getElementById(hash.slice(1));
  if (!target) return;

  event.preventDefault();

  const container = getScrollContainer();
  const containerRect = container.getBoundingClientRect();
  const targetRect = target.getBoundingClientRect();
  const headerHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
  const destination = targetRect.top - containerRect.top + container.scrollTop - headerHeight;

  container.scrollTo({ top: Math.max(destination, 0), behavior: 'instant' });
  history.pushState ? history.pushState(null, '', hash) : (window.location.hash = hash);
});
